import React, { useEffect, useRef, useState } from "react";
import actions from "../../actions";
import { useDispatch, useSelector } from "react-redux";
import LoadingOverlay from "react-loading-overlay";
import Loader from "../../../common/components/Loader";
import { checkPermission, findPrevPathFromBreadCrumpData, popBreadCrumpOnPageClose, removeAllTags, showAlert } from "../../../../config/utils";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import refreshIcon from "../../../../assets/img/img-refresh.svg";
import moment from "moment";
import { FilterSearch } from "../../../assets/components/FilterModal/FilterSearch";
import history from "../../../../config/history";
import { ProgressBar } from "react-bootstrap";
import Portal from "../../../common/components/Portal";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import { AIValuesModal } from "./AIValuesModal";
import { ReferenceFieldsModal } from "./ReferenceFieldsModal";
import { RichEditorPopup } from "../../../common/components/formFields/RichEditorPopup";
import { ImageViewV2 } from "../../../common/components/ImageComponents/ImageViewModalV2";
import { AIAnalyseStatus } from "../../constants";
import AnalyseBand from "./AnalyseBand";
import ReactSelect from "react-select";
import Draggable from "react-draggable";
import ReactTooltip from "react-tooltip";
import { EllipsisTooltipText } from "../../../common/components/EllipsisTextWithTooltip";
import NumberFormat from "react-number-format";
import { DYNAMIC_FIELD_TYPES } from "../../../common/constants";
import mobileRecomActions from "../../../mobileRecommendation/actions";
import { AIValueEditModal } from "./AIValueEditModal";

const SAVE_MODAL_EXCLUDED_KEYS = ["System", "Sub_System", "Trade"];
const MEMO_EDIT_FIELDS = ["Narrative", "Recommendation"];

const AIAnalyse = ({ detailedData, isMobEdit = false }) => {
    const onAnalyse = useRef(null);
    const onCancelAnalyse = useRef(null);
    const resetModalRef = useRef(null);
    const zoomInModalRef = useRef(null);
    const zoomOutModalRef = useRef(null);
    const viewImageHandler = useRef(null);
    const onAnalyseSave = useRef(null);
    const dispatch = useDispatch();
    const {
        getAiAnalyseResponse,
        postAiAnalyseResponse,
        getSurveyAssetById,
        clearAiAnalyseResponse,
        getSurveyAssetImagesById,
        patchAiAnalyseResponse,
        getSurveyRecommendationsImagesById,
        patchAiAnalyseAssetResponse,
        getAiAnalyseKeys: assetAiAnalyseKeys
    } = useSelector(state => state.assetSurveyProjectReducer);
    const { getMobileRecommendationByIdResponse, getAiAnalyseKeys: recomAiAnalyseKeys } = useSelector(
        state => state.mobileRecommendationsReducer
    );
    const { id, section, tab } = useParams();
    const [fieldSearch, setFieldSearch] = useState("");
    const [initialLoader, setInitialLoader] = useState(false);
    const [percentage, setPercentage] = useState(null);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [analysedData, setAnalyzedData] = useState([]);
    const [loadingBand, setLoadingBand] = useState([]);
    const basicDetails = analysedData;
    const [imagePopup, setImagePopup] = useState(false);
    const [imageList, setImageList] = useState(null);
    const [selectedImage, setSelectedImage] = useState([]);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [showAdditionalModalButtons, setShowAdditionalModalButtons] = useState(false);
    const [accordionOpen, setAccordionOpen] = useState({});
    const [outerAccordionOpen, setOuterAccordionOpen] = useState({});
    const [onReferenceFieldClick, setReferenceFieldClick] = useState(null);
    const [showRichTextPopup, setShowRichTextPopup] = useState({ value: "", label: "", key: "", show: false });
    const [assetData, setAssetData] = useState({});
    const [showAssetConfirmation, setAssetConfirmation] = useState(false);
    const [selectedAssetSaveValues, setSelectedAssetSaveValues] = useState({});
    const [showSaveAllFieldsModal, setShowSaveAllFieldsModal] = useState(false);
    const [showSaveAllFieldsCancelConfirmation, setShowSaveAllFieldsCancelConfirmation] = useState(false);
    const [initialAssetSaveValues, setInitialAssetSaveValues] = useState({});
    const [editValue, setEditValue] = useState(null);
    const editingClosedAt = useRef(0);

    const scrollRefs = useRef({});
    const scrollOuterRefs = useRef({});
    const outerScrollRef = useRef({});
    const isMobileRecommendation = section === "mobrecomsinfo" || isMobEdit;
    const isConverted = isMobileRecommendation
        ? (getMobileRecommendationByIdResponse?.recommendation?.status ?? detailedData?.status) === 4
        : (getSurveyAssetById?.data?.asset?.status ?? detailedData?.status) === 5;
    const saveDisabledReason = isConverted
        ? isMobileRecommendation
            ? "This Mobile Recommendation has been Converted and cannot be edited."
            : "This Mobile Asset has been Moved to Production and cannot be edited"
        : "";
    const aiAnalyseKeys = isMobileRecommendation ? recomAiAnalyseKeys : assetAiAnalyseKeys;
    const saveToLabel = `Save to Mobile ${isMobileRecommendation ? "Recommendation" : "Asset"}`;
    useEffect(() => {
        if (isMobileRecommendation) dispatch(actions.getSurveyRecommendationImagesById(id));
        else dispatch(actions.getSurveyAssetImagesById(id));
        if (getSurveyAssetById?.data?.asset?.id !== id && !isMobileRecommendation) {
            dispatch(actions.getSurveyAssetById(id));
            setInitialLoader(true);
        }
        setAnalyzedData([]);
        setAccordionOpen({});
        setOuterAccordionOpen({});
    }, [id]);

    useEffect(() => {
        if (getSurveyAssetById?.data?.asset?.id !== id && !isMobileRecommendation) dispatch(actions.getSurveyAssetById(id));
        if (!Array.isArray(aiAnalyseKeys?.data)) {
            dispatch(isMobileRecommendation ? mobileRecomActions.getAiAnalyseKey() : actions.getAiAnalyseKey());
        }
        setInitialLoader(true);
        return () => {
            dispatch(actions?.resetAiReducer());
        };
    }, []);

    useEffect(() => {
        if (
            (getSurveyAssetById?.success && getSurveyAssetById?.data?.asset?.id === id && !isMobileRecommendation) ||
            (isMobileRecommendation && id)
        ) {
            refreshData(true);
            setInitialLoader(true);
        }
    }, [getSurveyAssetById, id, section]);

    useEffect(() => {
        if (onAnalyse?.current && postAiAnalyseResponse?.status !== undefined) {
            onAnalyse.current = false;
            const { status, message, detail = null } = postAiAnalyseResponse;
            if (status) {
                if (message) showAlert(message);
                setInitialLoader(true);
                refreshData(true);
            } else {
                showAlert(typeof detail === "string" ? detail : message);
            }
        }
    }, [postAiAnalyseResponse]);
    useEffect(() => {
        if (onCancelAnalyse?.current && clearAiAnalyseResponse?.status !== undefined) {
            onAnalyse.current = false;
            const { status, message, detail = null } = clearAiAnalyseResponse;
            if (status) {
                if (message) showAlert(message);
                setInitialLoader(true);
                refreshData();
            } else {
                showAlert(typeof detail === "string" ? detail : message);
            }
        }
    }, [clearAiAnalyseResponse]);

    useEffect(() => {
        if (getAiAnalyseResponse?.status !== undefined) {
            const { status, message, detail = null } = getAiAnalyseResponse;
            if (status) {
                if (getAiAnalyseResponse?.results?.[0]?.analyze_percentage !== undefined) {
                    setPercentage(getAiAnalyseResponse?.results?.[0]?.analyze_percentage);
                    setAssetData(getAiAnalyseResponse?.original_values || {});
                    setAnalyzedData(getAiAnalyseResponse?.results ?? {});
                    if (getAiAnalyseResponse?.isInitialCall) {
                        const initialOuterState = {};
                        (getAiAnalyseResponse?.results || [])?.forEach((outerBand, outerIndex) => {
                            const isAnyInnerOpen = Object.values(outerBand?.config_json || {})?.some(item => item?.band === "open");
                            initialOuterState[outerIndex] = outerIndex === 0 || isAnyInnerOpen;
                        });
                        setOuterAccordionOpen(initialOuterState);

                        const initialInnerState = {};
                        (getAiAnalyseResponse?.results || [])?.forEach((outerBand, outerIndex) => {
                            ["analysis", "template"]?.forEach((type, subIndex) => {
                                const key = `${outerIndex}-${subIndex}`;
                                initialInnerState[key] = outerBand?.config_json?.[type]?.band === "open";
                            });
                        });
                        setAccordionOpen(initialInnerState);
                    }
                }
            } else {
                setPercentage(0);
                showAlert(typeof detail === "string" ? detail : message);
            }
            setInitialLoader(false);
        }
    }, [getAiAnalyseResponse]);

    useEffect(() => {
        let intervalId;
        if (percentage !== null && percentage !== 100) {
            intervalId = setInterval(() => {
                refreshData();
            }, 30000);
        }
        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [percentage]);
    useEffect(() => {
        if (getSurveyAssetImagesById) {
            setSelectedImage([...(getSurveyAssetImagesById?.data?.image ?? []), ...(getSurveyAssetImagesById?.data?.added_image ?? [])]?.[0]);
            setImageList({ images: [...(getSurveyAssetImagesById?.data?.image ?? []), ...(getSurveyAssetImagesById?.data?.added_image ?? [])] });
        }
    }, [getSurveyAssetImagesById]);

    useEffect(() => {
        if (getSurveyRecommendationsImagesById && isMobileRecommendation) {
            setSelectedImage(
                [...(getSurveyRecommendationsImagesById?.data?.image ?? []), ...(getSurveyRecommendationsImagesById?.data?.added_image ?? [])]?.[0]
            );
            setImageList({
                images: [...(getSurveyRecommendationsImagesById?.data?.image ?? []), ...(getSurveyRecommendationsImagesById?.data?.added_image ?? [])]
            });
        }
    }, [getSurveyRecommendationsImagesById]);

    const hasImages = !!imageList?.images?.length;

    useEffect(() => {
        if (!hasImages && imagePopup) setImagePopup(false);
    }, [hasImages]);

    useEffect(() => {
        if (selectedImage?.master_image?.s3_image_key || selectedImage?.s3_image_key) {
            setImageLoaded(false);
            const img = new Image();
            img.src = selectedImage?.master_image?.s3_image_key || selectedImage?.s3_image_key;
            img.onload = () => setImageLoaded(true);
        }
    }, [selectedImage]);

    useEffect(() => {
        if (patchAiAnalyseResponse?.status !== undefined) {
            const { status, message, request_id, result_type } = patchAiAnalyseResponse || {};
            if (status) {
                setLoadingBand(prev => (prev ?? [])?.filter(item => !(item?.request_id === request_id && item?.type === result_type)));
                refreshData();
            } else {
                showAlert(message);
            }
            dispatch(actions.resetPatchAiAnalyse());
        }
    }, [patchAiAnalyseResponse]);

    useEffect(() => {
        if (patchAiAnalyseAssetResponse?.status !== undefined && onAnalyseSave?.current) {
            const { status, message } = patchAiAnalyseAssetResponse || {};
            if (status) {
                showAlert(message);
                refreshData();
                resetAssetConfirmation();
            } else {
                showAlert(message);
            }
            onAnalyseSave.current = false;
        }
    }, [patchAiAnalyseAssetResponse]);

    const refreshData = (isInitialCall = false) => {
        dispatch(
            actions?.getAiAnalyseData(
                {
                    table_mobile_id: id,
                    ...(isMobileRecommendation ? {} : { table_guid: getSurveyAssetById?.data?.asset?.guid ?? detailedData?.guid }),
                    source: isMobileRecommendation ? "mobile_recom" : "mobile_asset"
                },
                isInitialCall
            )
        );
    };

    const onAIAnalyseClick = () => {
        onAnalyse.current = true;
        dispatch(
            actions?.postAiAnalyse({
                table_mobile_id: id,
                ...(isMobileRecommendation ? {} : { table_guid: getSurveyAssetById?.data?.asset?.guid ?? detailedData?.guid }),
                source: isMobileRecommendation ? "mobile_recom" : "mobile_asset"
            })
        );
    };

    const renderBandFields = bandData => {
        const mainFields = {};
        const restFields = {};
        const search = fieldSearch?.toLowerCase();

        const processValue = (value, keyPrefix = "", currentKey = "") => {
            const rawLabel = currentKey?.replace(/_/g, " ") || "";
            const label = rawLabel.charAt(0).toUpperCase() + rawLabel.slice(1);
            const strValue = value != null && typeof value !== "object" ? String(value) : "";

            const matchesSearch = rawLabel?.toLowerCase()?.includes(search);

            if (value && typeof value === "object" && !Array.isArray(value)) {
                Object.keys(value || {})?.forEach(k => {
                    const nestedKey = keyPrefix ? `${keyPrefix}_${k}` : k;
                    processValue(value[k], nestedKey, k);
                });
            } else if (Array.isArray(value)) {
                const field = { label, value };
                if (!fieldSearch || matchesSearch) {
                    if (Object.keys(mainFields).length < 3) mainFields[keyPrefix] = field;
                    else restFields[keyPrefix] = field;
                }
            } else {
                const field = { label, value: strValue };
                if (!fieldSearch || matchesSearch) {
                    if (Object.keys(mainFields)?.length < 3) mainFields[keyPrefix] = field;
                    else restFields[keyPrefix] = field;
                }
            }
        };

        processValue(bandData);

        return { mainFields, restFields };
    };

    const extractKeys = obj => {
        let results = [];
        if (obj && typeof obj === "object") {
            Object.entries(obj || {}).forEach(([key, val]) => {
                if (val && typeof val === "object") {
                    results = results.concat(extractKeys(val));
                } else {
                    if (key?.toLowerCase() === "item_id") return;
                    const label = key?.replace(/_/g, " ");
                    results.push({
                        label: label?.charAt(0)?.toUpperCase() + label?.slice(1)
                    });
                }
            });
        }

        results?.sort((a, b) => a.label.localeCompare(b.label));

        return results;
    };

    const renderConfirmationModal = () => {
        if (!showConfirmationModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={"Do you want to initiate an AI Analysis?"}
                        onNo={() => setShowConfirmationModal(false)}
                        onYes={() => {
                            onAIAnalyseClick();
                            setShowConfirmationModal(false);
                        }}
                    />
                }
                onCancel={() => setShowConfirmationModal(false)}
            />
        );
    };
    const renderImagePopup = () => {
        if (!imagePopup) return null;
        return (
            <Portal
                body={
                    <ImageViewV2
                        initialImages={imageList?.images ?? []}
                        isSurveyAssetView
                        initialSelectedId={null}
                        onCancel={() => setImagePopup(false)}
                        noOverlay={true}
                    />
                }
                noOverlay={true}
                onCancel={() => setImagePopup(false)}
            />
        );
    };
    const onDefaultOpen = (outerBand, matchingResponse, bandType = "", index) => {
        const newStatus = outerBand?.config_json?.[matchingResponse?.result_type ?? bandType]?.band === "open" ? "close" : "open";
        dispatch(
            actions?.patchAiAnalyse({
                table_mobile_id: id,
                ...(isMobileRecommendation ? {} : { table_guid: getSurveyAssetById?.data?.asset?.guid ?? detailedData?.guid }),
                source: isMobileRecommendation ? "mobile_recom" : "mobile_asset",
                request_id: outerBand?.request_id,
                result_type: matchingResponse?.result_type ?? bandType,
                open_status: newStatus,
                first_index: index === 0 ? "yes" : "no",
                analyze_id: outerBand?.id
            })
        );
        setAnalyzedData(prevDetails =>
            prevDetails.map(band => {
                const hasMatchingResponse = band.request_id === outerBand?.request_id;
                if (hasMatchingResponse) {
                    const type = matchingResponse?.result_type ?? bandType;
                    return {
                        ...band,
                        config_json: {
                            ...band?.config_json,
                            [type]: {
                                ...band.config_json?.[type],
                                band: newStatus
                            }
                        }
                    };
                }

                return band;
            })
        );
        setLoadingBand(prev => [...prev, { request_id: outerBand?.request_id, type: matchingResponse?.result_type ?? bandType }]);
    };

    const allFields = [
        ...new Set(
            (basicDetails || []).reduce((acc, detail) => {
                (detail.response || []).forEach(item => {
                    acc.push(...extractKeys(item));
                });
                return acc;
            }, [])
        )
    ];
    const scrollToBand = el => {
        if (!el) return;

        const container = outerScrollRef?.current;
        if (!container) return;

        const elRect = el?.getBoundingClientRect();
        const containerRect = container?.getBoundingClientRect();

        container.scrollBy({
            top: elRect.top - containerRect?.top - 50,
            behavior: "smooth"
        });
    };

    const toggleInnerAccordion = (outerIndex, subIndex) => {
        const key = `${outerIndex}-${subIndex}`;

        setAccordionOpen(prev => {
            const isCurrentlyOpen = !!prev[key];
            const newState = {
                ...prev,
                [key]: !isCurrentlyOpen
            };

            if (!isCurrentlyOpen) {
                setTimeout(() => scrollToBand(scrollRefs?.current?.[key]), 300);
            }

            return newState;
        });
    };

    const renderReferenceField = () => {
        if (!onReferenceFieldClick) return null;
        const ReferenceFieldComponent = onReferenceFieldClick?.useReferenceTable ? ReferenceFieldsModal : AIValuesModal;
        return (
            <Portal
                body={
                    <ReferenceFieldComponent
                        fieldValue={onReferenceFieldClick?.value ?? []}
                        hideHeader={false}
                        showSaveAction={onReferenceFieldClick?.showSaveAction ?? false}
                        onSaveValue={value => {
                            if (!onReferenceFieldClick?.saveFieldName) return;
                            onAssetValueSave({ [onReferenceFieldClick?.saveFieldName]: value });
                        }}
                        getSaveDisabledReason={() => onReferenceFieldClick?.saveDisabledReason ?? ""}
                        onEditValue={value => {
                            if (!onReferenceFieldClick?.saveFieldName) return;
                            onEditValueClick(onReferenceFieldClick?.saveFieldName, value, onReferenceFieldClick?.label);
                        }}
                        heading={
                            onReferenceFieldClick?.label
                                ? onReferenceFieldClick?.label?.replace(/_/g, " ")?.replace(/\w\S*/g, w => w?.charAt(0)?.toUpperCase() + w?.slice(1))
                                : ""
                        }
                        onCancel={() => {
                            setReferenceFieldClick(null);
                        }}
                    />
                }
                onCancel={() => {
                    setReferenceFieldClick(null);
                }}
            />
        );
    };
    const filteredBand = basicDetails
        ?.map(outerBand => {
            const filteredResponse = (outerBand?.response || [])?.filter(item => {
                return Object.values(item || {})
                    .flatMap(val => (val && typeof val === "object" ? Object.keys(val || {}) : [val]))
                    .some(v => v?.replace(/_/g, " ")?.toLowerCase()?.includes(fieldSearch?.toLowerCase()));
            });
            if (!filteredResponse?.length) return null;

            return { ...outerBand, response: filteredResponse };
        })
        ?.filter(Boolean);

    const renderRichTextPopup = () => {
        const { label, key, show, value, saveFieldName } = showRichTextPopup;
        if (!show) return null;
        const closeRichTextPopup = () => setShowRichTextPopup({ value: "", label: "", key: "", show: false, saveFieldName: "" });
        return (
            <Portal
                body={
                    <RichEditorPopup
                        value={value}
                        label={label}
                        key={key}
                        editorKey={saveFieldName ? `ai-save-all-${saveFieldName}` : undefined}
                        onCancel={closeRichTextPopup}
                        isReadOnly={!saveFieldName}
                        saveLabel="Apply"
                        saveData={data => {
                            if (!saveFieldName) return;
                            setSelectedAssetSaveValues(prev => ({
                                ...prev,
                                [saveFieldName]: { ...prev?.[saveFieldName], selected: prev?.[saveFieldName]?.selected ?? true, value: data }
                            }));
                        }}
                    />
                }
                onCancel={closeRichTextPopup}
            />
        );
    };

    const formatFieldLabel = fieldName => {
        const label = fieldName?.replace(/_/g, " ") || "";
        return label?.charAt?.(0).toUpperCase() + label?.slice?.(1);
    };

    const getSelectableValueOptions = value => {
        if (value === null || value === undefined || value === "") return [];

        if (Array.isArray(value)) {
            return value?.map(item => (typeof item === "object" && item !== null ? JSON.stringify(item) : item?.toString()))?.filter(Boolean);
        }

        if (typeof value !== "string") return [value];

        const trimmedValue = value.trim();
        if (!trimmedValue?.startsWith("[") || !trimmedValue.endsWith("]")) return [value];

        try {
            const parsedValue = JSON.parse(trimmedValue);
            if (Array.isArray(parsedValue)) {
                return parsedValue
                    ?.map(item => (typeof item === "object" && item !== null ? JSON.stringify(item) : item?.toString()))
                    ?.filter(Boolean);
            }
        } catch (error) {}

        const innerValue = trimmedValue.slice(1, -1)?.trim();
        if (!innerValue) return [];

        const separator = innerValue.includes(";") ? ";" : ",";
        return innerValue
            ?.split(separator)
            ?.map(item => item?.trim())
            ?.filter(Boolean);
    };

    const getDefaultSelectedSaveValues = values =>
        Object.keys(values || {})?.reduce((acc, key) => {
            // if (SAVE_MODAL_EXCLUDED_KEYS?.includes(key)) return acc;

            const options = getSelectableValueOptions(values?.[key]);
            if (options?.length) {
                acc[key] = {
                    selected: true,
                    value: options?.[0],
                    options
                };
            }
            return acc;
        }, {});

    const getComparableAssetSaveValues = values =>
        Object.keys(values || {})
            ?.sort()
            ?.reduce((acc, key) => {
                acc[key] = {
                    selected: values?.[key]?.selected ?? false,
                    value: values?.[key]?.value ?? null
                };
                return acc;
            }, {});

    const hasAssetSaveValuesChanged = () =>
        JSON.stringify(getComparableAssetSaveValues(selectedAssetSaveValues)) !== JSON.stringify(getComparableAssetSaveValues(initialAssetSaveValues));

    const resetAssetConfirmation = () => {
        setAssetConfirmation(false);
        setSelectedAssetSaveValues({});
        setInitialAssetSaveValues({});
        setShowSaveAllFieldsModal(false);
        setShowSaveAllFieldsCancelConfirmation(false);
        setEditValue(null);
        setReferenceFieldClick(null);
    };

    const onSaveAllFieldsCancel = () => {
        const editingField = Object.keys(selectedAssetSaveValues || {})?.find(key => selectedAssetSaveValues?.[key]?.editing);
        if (editingField) {
            editingClosedAt.current = Date.now();
            setSelectedAssetSaveValues(prev => ({ ...prev, [editingField]: { ...prev?.[editingField], editing: false } }));
            return;
        }
        if (Date.now() - editingClosedAt.current < 300) return;
        if (hasAssetSaveValuesChanged()) {
            setShowSaveAllFieldsCancelConfirmation(true);
            return;
        }
        resetAssetConfirmation();
    };

    const onAssetValueSave = (response, isHierarchy = false, selectedAll = false) => {
        if (selectedAll) {
            const defaultSelectedValues = getDefaultSelectedSaveValues(response);
            setSelectedAssetSaveValues(defaultSelectedValues);
            setInitialAssetSaveValues(defaultSelectedValues);
            setShowSaveAllFieldsModal(true);
        } else {
            setAssetConfirmation(response);
            setSelectedAssetSaveValues({});
            setInitialAssetSaveValues({});
            setShowSaveAllFieldsCancelConfirmation(false);
            setShowSaveAllFieldsModal(false);
        }
    };
    const onAssetUpdate = (field = {}) => {
        onAnalyseSave.current = true;
        dispatch(
            actions.saveAiAnalyseAssetData({
                table_mobile_id: id,
                ...(isMobileRecommendation ? {} : { table_guid: getSurveyAssetById?.data?.asset?.guid ?? detailedData?.guid }),
                ai_response: { required_fields: { ...field } },
                ...(getAiAnalyseResponse?.recom_type ? { recom_type: getAiAnalyseResponse?.recom_type ?? detailedData?.recom_type } : {}),
                source: isMobileRecommendation ? "mobile_recom" : "mobile_asset"
            })
        );
    };

    const renderSaveAllFieldsModal = () => {
        if (!showSaveAllFieldsModal) return null;
        const fieldEntries = Object.entries(selectedAssetSaveValues || {});
        const selectedPayload = Object.keys(selectedAssetSaveValues || {})?.reduce((acc, key) => {
            if (selectedAssetSaveValues?.[key]?.selected) acc[key] = selectedAssetSaveValues?.[key]?.value;
            return acc;
        }, {});
        const hasSelectedValues = Object.keys(selectedPayload || {})?.length > 0;
        const hasEmptySelectedValue = Object.values(selectedPayload || {})?.some(value => String(value ?? "")?.trim() === "");
        const canSaveAll = hasSelectedValues && !hasEmptySelectedValue && !patchAiAnalyseAssetResponse?.loading;
        const updateSaveValue = (fieldName, value) =>
            setSelectedAssetSaveValues(prev => ({
                ...prev,
                [fieldName]: { ...prev?.[fieldName], selected: prev?.[fieldName]?.selected ?? true, value }
            }));
        const stopEditing = fieldName => {
            editingClosedAt.current = Date.now();
            setSelectedAssetSaveValues(prev => ({ ...prev, [fieldName]: { ...prev?.[fieldName], editing: false } }));
        };
        const getEditInputHandlers = fieldName => ({
            onBlur: () => stopEditing(fieldName),
            onKeyDown: e => {
                if (e.key === "Enter" || e.key === "Escape") {
                    e.preventDefault();
                    e.stopPropagation();
                    stopEditing(fieldName);
                }
            }
        });

        return (
            <Portal
                body={
                    <div className="modal analyse_reference_modal save_all_modal" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-lg" role="document">
                            <Draggable handle=".draggable" cancel=".not-draggable">
                                <div className="modal-content">
                                    <div className="modal-header draggable">
                                        <h5 className="modal-title">
                                            Save AI Analyzed Values to Mobile {isMobileRecommendation ? "Recommendation" : "Asset"}
                                        </h5>
                                        <button type="button" className="close" onClick={onSaveAllFieldsCancel}>
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div className="modal-body analyse_reference_body">
                                        <div className="table-responsive analyse_asset_save_table_scroll">
                                            <table className="analyse_reference_table analyse_asset_save_table">
                                                <colgroup>
                                                    <col className="select-column-col" />
                                                    <col className="field-column-col" />
                                                    <col className="value-column-col" />
                                                </colgroup>
                                                <thead>
                                                    <tr>
                                                        <th className="select-column">Select</th>
                                                        <th className="field-column">Field</th>
                                                        <th className="value-column">Value</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {fieldEntries?.map(([fieldName, fieldData]) => {
                                                        const options = fieldData?.options ?? [];
                                                        const isSelected = fieldData?.selected ?? false;
                                                        const selectedValue = fieldData?.value ?? options?.[0];
                                                        const reactSelectOptions = options?.map(option => ({ label: option, value: option }));
                                                        const isEditing = fieldData?.editing ?? false;
                                                        const editType = getEditType(fieldName);
                                                        const fieldRules = getAiFieldConfig(fieldName)?.rules || {};
                                                        const canEdit = !SAVE_MODAL_EXCLUDED_KEYS.includes(fieldName) && options?.length <= 1;
                                                        return (
                                                            <tr key={fieldName}>
                                                                <td
                                                                    className="select-column cursor-hand"
                                                                    onClick={() => {
                                                                        setSelectedAssetSaveValues(prev => ({
                                                                            ...prev,
                                                                            [fieldName]: {
                                                                                ...prev?.[fieldName],
                                                                                selected: !(prev?.[fieldName]?.selected ?? false),
                                                                                value: prev?.[fieldName]?.value ?? options?.[0]
                                                                            }
                                                                        }));
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        className="cursor-hand"
                                                                        checked={isSelected}
                                                                        style={{ width: "16px", height: "16px" }}
                                                                        onChange={() => {}}
                                                                    />
                                                                </td>
                                                                <td className="field-column">
                                                                    <EllipsisTooltipText
                                                                        className="analyse-asset-save-ellipsis"
                                                                        text={formatFieldLabel(fieldName)}
                                                                    />
                                                                </td>
                                                                <td className="value-column">
                                                                    <div className="analyse-asset-save-value-wrap">
                                                                    {isEditing && editType === "number" ? (
                                                                        <NumberFormat
                                                                            autoComplete="off"
                                                                            className="form-control analyse-asset-save-input"
                                                                            value={selectedValue ?? ""}
                                                                            thousandSeparator={fieldRules?.thousand_separator}
                                                                            prefix={fieldRules?.prefix}
                                                                            suffix={fieldRules?.suffix}
                                                                            decimalScale={fieldRules?.decimal_scale}
                                                                            allowNegative={fieldRules?.allow_negative}
                                                                            displayType="input"
                                                                            onValueChange={values => updateSaveValue(fieldName, values?.value ?? "")}
                                                                            {...getEditInputHandlers(fieldName)}
                                                                        />
                                                                    ) : isEditing && editType === "text" ? (
                                                                        <input
                                                                            type="text"
                                                                            autoComplete="off"
                                                                            className="form-control analyse-asset-save-input"
                                                                            value={selectedValue ?? ""}
                                                                            onChange={e => updateSaveValue(fieldName, e.target.value)}
                                                                            {...getEditInputHandlers(fieldName)}
                                                                        />
                                                                    ) : isEditing && editType === "string" ? (
                                                                        <input
                                                                            type="text"
                                                                            autoFocus
                                                                            autoComplete="off"
                                                                            className="form-control analyse-asset-save-input"
                                                                            value={selectedValue ?? ""}
                                                                            onChange={e => updateSaveValue(fieldName, e.target.value)}
                                                                            {...getEditInputHandlers(fieldName)}
                                                                        />
                                                                    ) : options?.length > 1 ? (
                                                                        <ReactSelect
                                                                            className="react-select-container"
                                                                            classNamePrefix="react-select"
                                                                            value={
                                                                                reactSelectOptions?.find(option => option?.value === selectedValue) ??
                                                                                null
                                                                            }
                                                                            isDisabled={!isSelected}
                                                                            options={reactSelectOptions}
                                                                            menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                                                                            styles={{
                                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                                control: base => ({
                                                                                    ...base,
                                                                                    minHeight: "32px",
                                                                                    fontSize: "13px"
                                                                                }),
                                                                                valueContainer: base => ({
                                                                                    ...base,
                                                                                    padding: "0 8px"
                                                                                }),
                                                                                indicatorsContainer: base => ({
                                                                                    ...base,
                                                                                    height: "30px"
                                                                                })
                                                                            }}
                                                                            onChange={selectedOption => {
                                                                                setSelectedAssetSaveValues(prev => ({
                                                                                    ...prev,
                                                                                    [fieldName]: {
                                                                                        ...prev?.[fieldName],
                                                                                        selected: prev?.[fieldName]?.selected ?? true,
                                                                                        value: selectedOption?.value
                                                                                    }
                                                                                }));
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <EllipsisTooltipText
                                                                            className="analyse-asset-save-ellipsis"
                                                                            text={
                                                                                editType === "memo"
                                                                                    ? removeAllTags(selectedValue ?? "") || "-"
                                                                                    : selectedValue ?? "-"
                                                                            }
                                                                        />
                                                                    )}
                                                                    {canEdit && (
                                                                        <i
                                                                            className={`fa fa-pencil-alt ml-2 ai-edit-icon ${
                                                                                isSelected ? "cursor-hand" : "cursor-disabled"
                                                                            }`}
                                                                            style={{ color: isEditing ? "#0d6efd" : "#4B90FA" }}
                                                                            data-tip={!isSelected ? "Select the field to edit" : isEditing ? "Done" : "Edit"}
                                                                            data-for="asset-info-tooltips"
                                                                            onClick={() => {
                                                                                if (!isSelected) return;
                                                                                if (editType === "memo") {
                                                                                    setShowRichTextPopup({
                                                                                        show: true,
                                                                                        label: formatFieldLabel(fieldName),
                                                                                        value: selectedValue ?? "",
                                                                                        key: fieldName,
                                                                                        saveFieldName: fieldName
                                                                                    });
                                                                                    return;
                                                                                }
                                                                                setSelectedAssetSaveValues(prev => ({
                                                                                    ...prev,
                                                                                    [fieldName]: { ...prev?.[fieldName], editing: !isEditing }
                                                                                }));
                                                                            }}
                                                                        />
                                                                    )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary btnClr footer-button" onClick={onSaveAllFieldsCancel}>
                                            Cancel
                                        </button>
                                        <span
                                            className="d-inline-block ml-2"
                                            data-tip={
                                                hasEmptySelectedValue
                                                    ? "A selected field has an empty value"
                                                    : !hasSelectedValues
                                                      ? "Select at least one field"
                                                      : saveToLabel
                                            }
                                            data-for="asset-info-tooltips"
                                            data-place="top"
                                        >
                                            <button
                                                type="button"
                                                className={`btn btn-primary btnRgion footer-button ${canSaveAll ? "" : "cursor-disabled"}`}
                                                disabled={!canSaveAll}
                                                onClick={() => {
                                                    if (!canSaveAll) return;
                                                    setAssetConfirmation(selectedPayload);
                                                }}
                                            >
                                                {patchAiAnalyseAssetResponse?.loading ? (
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                ) : (
                                                    "Save"
                                                )}
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </Draggable>
                        </div>
                    </div>
                }
                onCancel={onSaveAllFieldsCancel}
            />
        );
    };

    const renderSaveAllFieldsCancelConfirmationModal = () => {
        if (!showSaveAllFieldsCancelConfirmation) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={"You have unsaved changes!"}
                        message={"This action cannot be reverted, are you sure you want to leave?"}
                        onNo={() => setShowSaveAllFieldsCancelConfirmation(false)}
                        onYes={resetAssetConfirmation}
                    />
                }
                onCancel={() => setShowSaveAllFieldsCancelConfirmation(false)}
            />
        );
    };

    const renderAssetConfirmationModal = () => {
        if (!showAssetConfirmation) return null;
        let label = "";
        const getMobileAssetValue = fieldName => {
            const entry = Object.values(assetData || {})?.find(item => item?.map_key === fieldName);
            return entry?.value;
        };
        const confirmationEntries = Object.entries(showAssetConfirmation || {})?.map(([fieldName, value]) => ({
            label: formatFieldLabel(fieldName),
            currentValue: getMobileAssetValue(fieldName),
            aiValue: value
        }));

        if (typeof showAssetConfirmation === "object" && Object.keys(showAssetConfirmation).length === 1) {
            const key = Object.keys(showAssetConfirmation || {})?.[0];
            label = (key?.replace(/_/g, " ") || "")?.charAt(0).toUpperCase() + (key?.replace(/_/g, " ") || "")?.slice(1);
        }
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={
                            Object.keys(showAssetConfirmation || {})?.length > 1 ? (
                                <div>
                                    Do you want to save the selected AI Analyzed field value to the Mobile{" "}
                                    {isMobileRecommendation ? "Recommendation" : "Asset"}
                                </div>
                            ) : (
                                <div className="mb-2">Do you want to replace:</div>
                            )
                        }
                        message={
                            label === "All" || (confirmationEntries ?? [])?.length > 1 ? null : (
                                <>
                                    Current Mobile {isMobileRecommendation ? "Recommendation" : "Asset"} <b>'{confirmationEntries?.[0]?.label}'</b>{" "}
                                    value of : <b className="confirmation-field-value">{confirmationEntries?.[0]?.currentValue ?? "null"}</b>
                                    <br />
                                    With
                                    <br />
                                    AI Analysis <b>'{confirmationEntries?.[0]?.label}</b>' value of :{" "}
                                    <b className="confirmation-field-value">{confirmationEntries?.[0]?.aiValue ?? "null"}</b>
                                </>
                            )
                        }
                        modalClassName="ai-analyze-confirmation-modal"
                        onNo={() => {
                            setAssetConfirmation(false);
                        }}
                        onYes={() => {
                            onAssetUpdate(showAssetConfirmation);
                            setAssetConfirmation(false);
                            setReferenceFieldClick(null);
                        }}
                    />
                }
                onCancel={() => {
                    setAssetConfirmation(false);
                }}
            />
        );
    };
    const getAiFieldConfig = fieldName => (aiAnalyseKeys?.data || [])?.find(field => field?.field_name === fieldName);

    const getEditType = fieldName => {
        const fieldType = getAiFieldConfig(fieldName)?.field_type;
        if (fieldType === DYNAMIC_FIELD_TYPES.NUMBER) return "number";
        if (fieldType === DYNAMIC_FIELD_TYPES.MEMO || MEMO_EDIT_FIELDS.includes(fieldName)) return "memo";
        if (fieldType === DYNAMIC_FIELD_TYPES.TEXT) return "text";
        return "string";
    };

    const onEditValueClick = (fieldName, value, label) => {
        setEditValue({
            fieldName,
            label: label || formatFieldLabel(fieldName),
            value: value === null || value === undefined ? "" : String(value),
            type: getEditType(fieldName),
            rules: getAiFieldConfig(fieldName)?.rules || {}
        });
    };

    useEffect(() => {
        if (showSaveAllFieldsModal || editValue) ReactTooltip.rebuild();
    }, [showSaveAllFieldsModal, editValue, selectedAssetSaveValues]);

    const renderEditValueModal = () => {
        if (!editValue) return null;
        return (
            <AIValueEditModal
                key={editValue?.fieldName}
                {...editValue}
                saveLabel={saveToLabel}
                isSaving={patchAiAnalyseAssetResponse?.loading}
                currentValue={Object.values(assetData || {})?.find(item => item?.map_key === editValue?.fieldName)?.value}
                entityLabel={isMobileRecommendation ? "Mobile Recom." : "Mobile Asset"}
                onSave={payload => setAssetConfirmation(payload)}
                onCancel={() => setEditValue(null)}
            />
        );
    };

    return (
        <LoadingOverlay active={getAiAnalyseResponse?.loading && initialLoader} spinner={<Loader />} fadeSpeed={10}>
            <div className="d-flex pb-2 m-2">
                <button
                    className="btn btn btn-primary refresh-btn"
                    onClick={e => {
                        e.preventDefault();
                        refreshData(true);
                        setInitialLoader(true);
                    }}
                >
                    <span className="icon mr-1">
                        <img src={refreshIcon} alt="" />
                    </span>
                    <span className="text">Refresh</span>
                </button>

                {checkPermission("forms", "ai_analysis", "create") ? (
                    !percentage || percentage === 100 ? (
                        <button
                            type="button"
                            className="btn btn-primary btnClr ai_analyse ml-2"
                            data-dismiss="modal"
                            onClick={() => {
                                setShowConfirmationModal(true);
                            }}
                        >
                            <div className="d-flex">AI Analysis</div>
                        </button>
                    ) : (
                        <div className="upload-sec cursor-hand ai-analyse-progress-bar-container ml-2 d-flex pl-2 pr-2">
                            <div className=" mt-2 d-flex">
                                <span
                                    data-tip={"Close"}
                                    data-for="asset-info-tooltips"
                                    data-place="bottom"
                                    data-effect="solid"
                                    onClick={() => {}}
                                    className="text"
                                >
                                    {`AI Analyzing ${percentage !== null && percentage !== undefined ? `(${percentage}%)` : ""}`}
                                </span>
                                <ProgressBar animated now={percentage ?? 0} style={{ marginRight: 0, marginLeft: "1px" }} />
                            </div>

                            <span
                                data-tip={"Close"}
                                data-for="asset-info-tooltips"
                                data-place="bottom"
                                data-effect="solid"
                                onClick={() => {
                                    setPercentage(null);
                                    dispatch(
                                        actions?.clearAiAnalyse({
                                            table_mobile_id: id,
                                            ...(isMobileRecommendation
                                                ? {}
                                                : { table_guid: getSurveyAssetById?.data?.asset?.guid ?? detailedData?.guid }),
                                            source: isMobileRecommendation ? "mobile_recom" : "mobile_asset",
                                            request_id: analysedData?.[0]?.request_id,
                                            analyze_id: analysedData?.[0]?.id
                                        })
                                    );
                                    onCancelAnalyse.current = true;
                                }}
                                className="edit-icn-bx pl-2 pr-2 pt-2 pb-0"
                            >
                                <i className="fas fa-times cursor-pointer"></i>
                            </span>
                        </div>
                    )
                ) : null}

                <div className="ml-auto d-flex gap-2">
                    <div className="edit-icn-container mt-2">
                        <span
                            className={`edit-icn-bx modal-view-icn  p-0 pr-3 ${hasImages ? "" : "cursor-disabled"}`}
                            onClick={() => hasImages && setImagePopup(!imagePopup)}
                            data-tip={hasImages ? "Image View Popup" : "No images available"}
                            data-for="asset-info-tooltips"
                            data-place="bottom"
                            data-effect="solid"
                        >
                            <img src="/img/img-icon.svg" alt="" style={hasImages ? undefined : { opacity: 0.4 }} />
                        </span>
                    </div>
                    <div className="search search-box-asset mr-2 not-draggable">
                        <FilterSearch fieldSearch={fieldSearch} setFieldSearch={setFieldSearch} fields={allFields} />
                    </div>

                    <span
                        data-tip={"Close"}
                        data-for="asset-info-tooltips"
                        data-place="bottom"
                        data-effect="solid"
                        onClick={() => {
                            popBreadCrumpOnPageClose();
                            history.push(findPrevPathFromBreadCrumpData());
                        }}
                        className="edit-icn-bx p-0 pl-4 pr-2 pt-2"
                    >
                        <i className="fas fa-window-close"></i> Close
                    </span>
                </div>
            </div>
            <div className="col-md-12 detail-recom scorll-flow analyse-accordion" ref={outerScrollRef}>
                <div className={` ${Object.keys(filteredBand || {})?.length ? "ai-analys-wrp" : "ai-analyse-nodata"}`}>
                    {Array.isArray(basicDetails) && filteredBand?.length ? (
                        <div className="accordion" id="aiAnalysisAccordion">
                            {filteredBand?.map((outerBand, outerIndex) => {
                                return (
                                    <div
                                        className="cnt-sec pb-0"
                                        key={`outer-${outerIndex}`}
                                        ref={el => {
                                            const key = `outer-${outerIndex}`;
                                            scrollOuterRefs.current[key] = el;
                                        }}
                                    >
                                        <div className="card ml-0 analyse-main mb-0">
                                            <div
                                                className="card-header"
                                                id={`main-heading-${outerIndex}`}
                                                onClick={() => {
                                                    setOuterAccordionOpen(prev => ({
                                                        ...prev,
                                                        [outerIndex]: !prev[outerIndex]
                                                    }));
                                                    setTimeout(() => scrollToBand(scrollOuterRefs?.current?.[`outer-${outerIndex}`]), 300);
                                                }}
                                            >
                                                <div
                                                    className={`outer-rcm recommendations otr-recom-div justify-content-between align-items-center ${
                                                        outerAccordionOpen[outerIndex] ? "" : "mb-3"
                                                    }`}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <button
                                                        className="btn p-2 first-txt"
                                                        aria-expanded={outerAccordionOpen?.[outerIndex] ? "true" : "false"}
                                                    >
                                                        <span>
                                                            Analysis{" "}
                                                            {outerBand?.created_at
                                                                ? `- ${moment(outerBand?.created_at).format("MM-DD-YYYY h:mm A")}`
                                                                : "-"}
                                                        </span>
                                                    </button>
                                                    <h5
                                                        className="mx-auto my-0 full-length"
                                                        style={{
                                                            color: "grey",
                                                            textAlign: "center"
                                                        }}
                                                    >
                                                        Click to
                                                        {outerAccordionOpen?.[outerIndex] ? " collapse" : " expand"}{" "}
                                                    </h5>
                                                    <div
                                                        class="check-area-top mr-3 align-items-center ml-auto"
                                                        onClick={e => {
                                                            e?.stopPropagation();
                                                        }}
                                                    >
                                                        <label for="" className="p-2 status-label" style={{ cursor: "auto" }}>
                                                            Status:{" "}
                                                            <span
                                                                className={`${AIAnalyseStatus?.[outerBand?.analyze_status]?.className || ""} ml-1`}
                                                                style={{
                                                                    color: AIAnalyseStatus?.[outerBand?.analyze_status]?.color || "#000"
                                                                }}
                                                            >
                                                                {AIAnalyseStatus?.[outerBand?.analyze_status]?.value || "-"}
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                id={`main-collapse-${outerIndex}`}
                                                className={`accordion-collapse collapse ${
                                                    outerAccordionOpen[outerIndex] ? "show" : ""
                                                } analyse-inner-band`}
                                                aria-labelledby={`main-heading-${outerIndex}`}
                                                data-bs-parent="#aiAnalysisAccordion"
                                            >
                                                <div className="accordion-body">
                                                    {["analysis", "template"]?.map((type, subIndex) => {
                                                        const matchingResponse = outerBand?.response?.find(r => r?.result_type === type);
                                                        if (!matchingResponse && fieldSearch) return null;
                                                        const isLoading = (loadingBand || [])?.some(
                                                            item => item?.request_id === outerBand?.request_id && item?.type === type
                                                        );
                                                        const matchingResponseKeyLength = Object.keys(matchingResponse || {})?.filter(
                                                            key => key !== "result_type" && key !== "request_id"
                                                        )?.length;

                                                        return (
                                                            <div className="accordion-item" key={`${outerIndex}-${type}`}>
                                                                <h2
                                                                    className="accordion-header d-flex justify-content-between align-items-center"
                                                                    id={`innerHeading-${outerIndex}-${subIndex}`}
                                                                    onClick={() => toggleInnerAccordion(outerIndex, subIndex)}
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    <button
                                                                        className="btn"
                                                                        type="button"
                                                                        aria-expanded={accordionOpen[`${outerIndex}-${subIndex}`] ? "true" : "false"}
                                                                        aria-controls={`innerCollapse-${outerIndex}-${subIndex}`}
                                                                    >
                                                                        <span>{type === "analysis" ? "AI Analysis" : "Template Data"}</span>
                                                                    </button>
                                                                    <h5
                                                                        className="mx-auto my-0 full-length"
                                                                        style={{
                                                                            textAlign: "center"
                                                                        }}
                                                                    >
                                                                        Click to
                                                                        {accordionOpen[`${outerIndex}-${subIndex}`] ? " collapse" : " expand"}{" "}
                                                                        {matchingResponseKeyLength ? "" : " (No Data Found)"}
                                                                    </h5>
                                                                    <div
                                                                        className="d-flex align-items-center pr-3 text-muted mr-3 def-open"
                                                                        style={{ fontSize: "13px", gap: "6px", cursor: "default" }}
                                                                        onClick={e => {
                                                                            e.stopPropagation();
                                                                        }}
                                                                    >
                                                                        <span>Default Open</span>

                                                                        {patchAiAnalyseResponse?.loading && isLoading ? (
                                                                            <div className="button-loader d-flex justify-content-center align-items-center mt-1">
                                                                                <div className="spinner-border" role="status">
                                                                                    <span className="sr-only">Loading...</span>
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={outerBand?.config_json?.[type]?.band === "open" ?? false}
                                                                                style={{
                                                                                    width: "14px",
                                                                                    height: "14px",
                                                                                    cursor: "pointer"
                                                                                }}
                                                                                onChange={() => {
                                                                                    onDefaultOpen(outerBand, matchingResponse, type, outerIndex);
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </h2>
                                                                <div
                                                                    id={`innerCollapse-${outerIndex}-${subIndex}`}
                                                                    className={`accordion-collapse collapse ${
                                                                        accordionOpen[`${outerIndex}-${subIndex}`] ? "show" : ""
                                                                    } ${matchingResponseKeyLength ? "" : "analyse_no_data"}`}
                                                                    aria-labelledby={`innerHeading-${outerIndex}-${subIndex}`}
                                                                    data-bs-parent={`#innerAccordion-${outerIndex}`}
                                                                    ref={el => {
                                                                        const key = `${outerIndex}-${subIndex}`;
                                                                        scrollRefs.current[key] = el;
                                                                    }}
                                                                >
                                                                    <div className={`accordion-body`}>
                                                                        {matchingResponseKeyLength ? (
                                                                            Object.keys(matchingResponse || {})
                                                                                ?.filter(
                                                                                    eachBand =>
                                                                                        typeof matchingResponse?.[eachBand] === "object" &&
                                                                                        matchingResponse?.[eachBand] !== null
                                                                                )
                                                                                ?.map((eachBand, index) => {
                                                                                    const { mainFields, restFields } = renderBandFields(
                                                                                        matchingResponse[eachBand]
                                                                                    );

                                                                                    if (
                                                                                        !Object.keys(mainFields)?.length &&
                                                                                        !Object.keys(restFields)?.length
                                                                                    )
                                                                                        return null;
                                                                                    return (
                                                                                        <AnalyseBand
                                                                                            keys={`${outerIndex}-${subIndex}-${index}`}
                                                                                            key={`${outerIndex}-${subIndex}-${eachBand}`}
                                                                                            band={eachBand?.replace(/_/g, " ")}
                                                                                            mainFields={mainFields}
                                                                                            restFields={restFields}
                                                                                            index={index}
                                                                                            isAiAnalyse
                                                                                            onReferenceFieldClick={(
                                                                                                value,
                                                                                                label,
                                                                                                saveOptions = {}
                                                                                            ) => {
                                                                                                setReferenceFieldClick({
                                                                                                    value,
                                                                                                    label,
                                                                                                    ...saveOptions
                                                                                                });
                                                                                            }}
                                                                                            containerKey={`${outerIndex}-${subIndex}`}
                                                                                            scrollContainerRef={scrollRefs}
                                                                                            setShowRichTextPopup={setShowRichTextPopup}
                                                                                            hasAssetValue={
                                                                                                isMobileRecommendation
                                                                                                    ? eachBand === "required_fields" ||
                                                                                                      eachBand === "Project_Specific"
                                                                                                    : eachBand === "required_fields"
                                                                                            }
                                                                                            onAssetValueSave={onAssetValueSave}
                                                                                            saveDisabledReason={saveDisabledReason}
                                                                                            onEditValueClick={onEditValueClick}
                                                                                            isMobileRecommendation={isMobileRecommendation ?? false}
                                                                                            assetValue={assetData ?? {}}
                                                                                            isDefaultOpen={
                                                                                                eachBand === "required_fields" ||
                                                                                                eachBand === "ai_recommendation"
                                                                                            }
                                                                                        />
                                                                                    );
                                                                                })
                                                                        ) : (
                                                                            <div
                                                                                className="coming-soon no-data no-dat"
                                                                                style={{ maxHeight: "100px", backgroundColor: "#F8FBFF" }}
                                                                            >
                                                                                <div className="coming-txt">
                                                                                    <h3>NO DATA FOUND</h3>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <div className="coming-soon no-data no-dat">
                            <div className="coming-soon-img">
                                <img src="/img/no-data.svg" alt="" />
                            </div>
                            <div className="coming-txt">
                                <h3>NO DATA FOUND</h3>
                                <h3 style={{ color: "#007bff" }}>Click the 'AI Analyze' button to analyze the data.</h3>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {renderConfirmationModal()}
            {renderImagePopup()}
            {renderReferenceField()}
            {renderRichTextPopup()}
            {renderSaveAllFieldsModal()}
            {renderSaveAllFieldsCancelConfirmationModal()}
            {renderAssetConfirmationModal()}
            {renderEditValueModal()}
            <ReactTooltip id="asset-info-tooltips" backgroundColor="#007bff" multiline place="bottom" effect="solid" />
        </LoadingOverlay>
    );
};
export default AIAnalyse;
